import { theme } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFloors } from 'reduxStore/floors/selectors';
import { selectSites } from 'reduxStore/sites/selectors';
import { Flex, Tabs, Typography } from 'zui/Antd';
import { DevicesTab, PeopleTab, TeamsTab } from './components';

const { Text } = Typography;

const SiteContent = ({ selectedSite, selectedFloor }) => {
	const {
		token: { colorText, paddingMD, paddingLG, paddingXL, borderRadiusLG, colorBorder }
	} = theme.useToken();

	const siteData = useSelector(selectSites).find((s) => s.siteID === selectedSite);
	const floorData = useSelector(selectFloors).find((f) => f.floorID === selectedFloor);

	const [activeKey, setActiveKey] = useState('people');

	useEffect(() => {
		setActiveKey(selectedFloor ? 'devices' : 'people');
	}, [selectedFloor, selectedSite]);

	const items = useMemo(
		() => [
			{
				key: 'people',
				label: 'People',
				disabled: !!selectedFloor,
				children: <PeopleTab selectedSite={selectedSite} />
			},
			{
				key: 'teams',
				label: 'Teams',
				disabled: !!selectedFloor,
				children: <TeamsTab selectedSite={selectedSite} />
			},
			{
				key: 'devices',
				label: 'Devices',
				disabled: false,
				children: <DevicesTab selectedSite={selectedSite} floorID={selectedFloor} />
			}
		],
		[selectedSite, selectedFloor]
	);

	return (
		<Flex
			vertical
			gap={8}
			style={{
				border: `1px solid ${colorBorder}`,
				borderRadius: borderRadiusLG,
				padding: `${paddingLG}px ${paddingXL}px`,
				marginBottom: paddingXL
			}}
		>
			<Text strong style={{ color: colorText, fontSize: 24 }}>
				{floorData ? floorData.name : siteData?.name}
			</Text>

			<Tabs activeKey={activeKey} onChange={setActiveKey} items={items} style={{ marginBottom: paddingMD }} />
		</Flex>
	);
};

export default SiteContent;
